// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pad-msg {\n  padding: 1.2rem;\n}\n\n.scrollable-home {\n  -ms-overflow-style: none;\n  /* for Internet Explorer, Edge */\n  scrollbar-width: none;\n  /* for Firefox */\n}\n.scrollable-home::-webkit-scrollbar {\n  display: none;\n}\n\n.avatar-header-container {\n  margin: 10px;\n}\n.avatar-header-container .avatar-header {\n  padding: 10px;\n}\n\n.scrol-height-home {\n  height: calc(100% - 142px);\n}", ""]);
// Exports
module.exports = exports;
